// src/components/notification-center/notification-center.tsx
function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_with_holes(arr) {
    if (Array.isArray(arr)) return arr;
}
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _async_to_generator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _iterable_to_array_limit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _non_iterable_rest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _sliced_to_array(arr, i) {
    return _array_with_holes(arr) || _iterable_to_array_limit(arr, i) || _unsupported_iterable_to_array(arr, i) || _non_iterable_rest();
}
function _tagged_template_literal(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
function _ts_generator(thisArg, body) {
    var f, y, t, g, _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    };
    return(g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g);
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
function _templateObject() {
    var data = _tagged_template_literal([
        "\n  fragment NotificationIconFragment on Icon {\n    description\n    title\n    token\n    theme\n    size\n    id\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _tagged_template_literal([
        "\n  fragment NotificationsFragment on RetailTravelAgentNotification {\n    id\n    readIndicator {\n      ...NotificationIconFragment\n    }\n    icon {\n      ...NotificationIconFragment\n    }\n    heading {\n      text\n      weight\n      theme\n    }\n    content {\n      text\n      weight\n      theme\n    }\n    link {\n      text\n      action {\n        accessibility\n        resource {\n          value\n        }\n        analytics {\n          linkName\n          referrerId\n        }\n        target\n      }\n    }\n    date\n    dismissButton {\n      analytics {\n        linkName\n        referrerId\n      }\n      icon {\n        ...NotificationIconFragment\n      }\n    }\n  }\n\n  ",
        "\n"
    ]);
    _templateObject1 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _tagged_template_literal([
        "\n  mutation ChangeNotificationState($id: ID!, $context: ContextInput!, $state: String!) {\n    changeNotificationState(id: $id, context: $context, state: $state) {\n      success\n      message\n    }\n  }\n"
    ]);
    _templateObject2 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = _tagged_template_literal([
        "\n  query NotificationMessagesCenterQuery($context: ContextInput!) {\n    retailTravelAgentNotificationCenter(context: $context) {\n      title\n      footerText\n      notifications {\n        ...NotificationsFragment\n      }\n    }\n  }\n\n  ",
        "\n"
    ]);
    _templateObject3 = function _templateObject() {
        return data;
    };
    return data;
}
import React5 from "react";
import { gql as gql3, useQuery } from "@apollo/client";
import { useBexApi as useBexApi2 } from "@shared-ui/bex-api-context";
import { UitkCard as UitkCard3, UitkCardContentSection as UitkCardContentSection4 } from "uitk-react-cards";
import { UitkLayoutGrid as UitkLayoutGrid4 } from "uitk-react-layout-grid";
import { UitkScrollable } from "uitk-react-scrollable";
import { UitkSpacing as UitkSpacing4 } from "uitk-react-spacing";
import { UitkHeading as UitkHeading3, UitkSubheading } from "uitk-react-text";
// src/components/notification-center/__private/_components/notification-center-empty-notifications.tsx
import React from "react";
import { UitkCard, UitkCardContentSection } from "uitk-react-cards";
import { UitkLayoutGrid } from "uitk-react-layout-grid";
import { UitkSpacing } from "uitk-react-spacing";
import { UitkHeading, UitkText } from "uitk-react-text";
var NotificationCenterEmptyNotifications = function(param) {
    var header = param.header, footer = param.footer;
    return /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement(UitkHeading, {
        size: 3,
        tag: "h2"
    }, header), /* @__PURE__ */ React.createElement(UitkSpacing, {
        margin: {
            blockstart: "six"
        }
    }, /* @__PURE__ */ React.createElement(UitkCard, {
        border: true
    }, /* @__PURE__ */ React.createElement(UitkCardContentSection, null, /* @__PURE__ */ React.createElement(UitkLayoutGrid, null, /* @__PURE__ */ React.createElement(UitkCardContentSection, {
        padded: [
            "inlinestart",
            "blockend",
            "blockstart"
        ]
    }, /* @__PURE__ */ React.createElement(UitkCardContentSection, {
        padded: [
            "inlinestart",
            "blockend",
            "blockstart"
        ]
    }, /* @__PURE__ */ React.createElement(UitkText, {
        size: 400
    }, footer))))))));
};
NotificationCenterEmptyNotifications.displayName = "NotificationCenterEmptyNotifications";
// src/components/notification-center/__private/_components/notification-center-loader.tsx
import React2 from "react";
import { UitkCard as UitkCard2, UitkCardContentSection as UitkCardContentSection2 } from "uitk-react-cards";
import { UitkLayoutGrid as UitkLayoutGrid2 } from "uitk-react-layout-grid";
import { UitkLineSkeleton } from "uitk-react-skeleton";
import { UitkSpacing as UitkSpacing2 } from "uitk-react-spacing";
import { UitkHeading as UitkHeading2 } from "uitk-react-text";
var NotificationContentSkeleton = function() {
    return /* @__PURE__ */ React2.createElement(UitkLayoutGrid2, null, /* @__PURE__ */ React2.createElement(UitkCard2, {
        padded: false
    }, /* @__PURE__ */ React2.createElement(UitkCardContentSection2, null, /* @__PURE__ */ React2.createElement(UitkLineSkeleton, null)), /* @__PURE__ */ React2.createElement(UitkCardContentSection2, null, /* @__PURE__ */ React2.createElement(UitkLineSkeleton, {
        animation: true,
        type: "secondary"
    })), /* @__PURE__ */ React2.createElement(UitkCardContentSection2, null, /* @__PURE__ */ React2.createElement(UitkLineSkeleton, null)), /* @__PURE__ */ React2.createElement(UitkCardContentSection2, null, /* @__PURE__ */ React2.createElement(UitkLineSkeleton, {
        animation: true,
        type: "secondary"
    }))));
};
var NotificationCenterLoader = function() {
    return /* @__PURE__ */ React2.createElement(React2.Fragment, null, /* @__PURE__ */ React2.createElement(UitkHeading2, {
        size: 3,
        tag: "h2"
    }, /* @__PURE__ */ React2.createElement(UitkLineSkeleton, null)), /* @__PURE__ */ React2.createElement(UitkSpacing2, {
        margin: {
            blockstart: "three"
        }
    }, /* @__PURE__ */ React2.createElement(UitkCard2, {
        border: true
    }, /* @__PURE__ */ React2.createElement(UitkCardContentSection2, {
        border: "top",
        padded: [
            "blockstart"
        ]
    }, /* @__PURE__ */ React2.createElement(NotificationContentSkeleton, null)), /* @__PURE__ */ React2.createElement(UitkCardContentSection2, {
        padded: true,
        border: "top"
    }, /* @__PURE__ */ React2.createElement(UitkLineSkeleton, null)))));
};
NotificationCenterLoader.displayName = "NotificationCenterLoader";
// src/components/notification-center/__private/__fragments/notification.tsx
import React4 from "react";
import { gql as gql2, useMutation } from "@apollo/client";
import { useBexApi } from "@shared-ui/bex-api-context";
import { useClickTracker } from "@shared-ui/clickstream-analytics-context";
import { UitkBadgeNotification } from "uitk-react-badge";
import { UitkTertiaryButton } from "uitk-react-button";
import { UitkCardContentSection as UitkCardContentSection3 } from "uitk-react-cards";
import { UitkLayoutFlex } from "uitk-react-layout-flex";
import { UitkLayoutGrid as UitkLayoutGrid3, UitkLayoutGridItem } from "uitk-react-layout-grid";
import { UitkLink } from "uitk-react-link";
import { UitkSpacing as UitkSpacing3, UitkSpacingHr } from "uitk-react-spacing";
import { UitkText as UitkText2 } from "uitk-react-text";
// src/components/notification-center/__private/__fragments/notification-icon.tsx
import React3 from "react";
import { gql } from "@apollo/client";
import { UitkIcon, UitkIconSize } from "uitk-react-icons";
// src/__generated__/types.ts
var IconTheme = /* @__PURE__ */ function(IconTheme2) {
    IconTheme2["default"] = "default";
    IconTheme2["emphasis"] = "emphasis";
    IconTheme2["inverse"] = "inverse";
    IconTheme2["negative"] = "negative";
    IconTheme2["positive"] = "positive";
    return IconTheme2;
}(IconTheme || {});
// src/components/notification-center/__private/__fragments/notification-icon.tsx
var notificationIconFragment = gql(_templateObject());
var NotificationIcon = function(param) {
    var data = param.data;
    return /* @__PURE__ */ React3.createElement(UitkIcon, {
        name: data.token,
        size: data.size ? UitkIconSize[data.size] : void 0,
        theme: data.theme ? IconTheme[data.theme] : void 0,
        title: data.description,
        id: data.id
    });
};
NotificationIcon.displayName = "NotificationIcon";
NotificationIcon.fragment = notificationIconFragment;
// src/components/notification-center/__private/__fragments/notification.tsx
var notificationFragment = gql2(_templateObject1(), NotificationIcon.fragment);
var __ChangeNotificationStateMutation = gql2(_templateObject2());
var UitkLinkTargetToUITKTargetMap = {
    EXTERNAL: "_blank",
    INTERNAL: "_self"
};
var themeToUitkTextThemeMap = {
    INVERSE: "inverse",
    LOYALTY: "loyalty",
    NEGATIVE: "negative",
    POSITIVE: "positive",
    PRIMARY: "emphasis",
    SECONDARY: "default",
    EMPHASIS: "emphasis"
};
var weightToUitkTextWeightMap = {
    BOLD: "bold",
    MEDIUM: "medium",
    REGULAR: "regular"
};
var Notification = function(param) {
    var data = param.data, showSeparator = param.showSeparator, queryToRefetch = param.queryToRefetch;
    var context = useBexApi().context;
    var trackClick = useClickTracker();
    var _useMutation = _sliced_to_array(useMutation(__ChangeNotificationStateMutation, {
        update: function update(cache) {
            var normalizedId = cache.identify({
                id: data.id,
                __typename: "RetailTravelAgentNotification"
            });
            cache.evict({
                id: normalizedId
            });
            cache.gc();
        },
        refetchQueries: function(mutationResult) {
            var _mutationResult_data_changeNotificationState, _mutationResult_data;
            return ((_mutationResult_data = mutationResult.data) === null || _mutationResult_data === void 0 ? void 0 : (_mutationResult_data_changeNotificationState = _mutationResult_data.changeNotificationState) === null || _mutationResult_data_changeNotificationState === void 0 ? void 0 : _mutationResult_data_changeNotificationState.success) ? [
                {
                    query: queryToRefetch,
                    variables: {
                        context: context
                    }
                }
            ] : [];
        }
    }), 2), updateNotificationState = _useMutation[0], _useMutation_ = _useMutation[1], loading = _useMutation_.loading, error = _useMutation_.error;
    var handleSetAsReadNotification = function() {
        var _ref = _async_to_generator(function(e) {
            return _ts_generator(this, function(_state) {
                switch(_state.label){
                    case 0:
                        e.preventDefault();
                        return [
                            4,
                            updateNotificationState({
                                variables: {
                                    id: data.id,
                                    context: context,
                                    state: "read"
                                }
                            })
                        ];
                    case 1:
                        _state.sent();
                        window.open(data.link.action.resource.value, UitkLinkTargetToUITKTargetMap[data.link.action.target]);
                        return [
                            2
                        ];
                }
            });
        });
        return function handleSetAsReadNotification(e) {
            return _ref.apply(this, arguments);
        };
    }();
    var handleSetAsDismissNotification = function() {
        var _ref = _async_to_generator(function(e) {
            return _ts_generator(this, function(_state) {
                switch(_state.label){
                    case 0:
                        e.preventDefault();
                        return [
                            4,
                            updateNotificationState({
                                variables: {
                                    id: data.id,
                                    context: context,
                                    state: "dismissed"
                                }
                            })
                        ];
                    case 1:
                        _state.sent();
                        return [
                            2
                        ];
                }
            });
        });
        return function handleSetAsDismissNotification(e) {
            return _ref.apply(this, arguments);
        };
    }();
    if (loading || error) {
        return null;
    }
    return /* @__PURE__ */ React4.createElement(UitkCardContentSection3, {
        tag: "article",
        padded: [
            "inlinestart",
            "inlineend"
        ]
    }, /* @__PURE__ */ React4.createElement(UitkLayoutGrid3, {
        columns: 24,
        space: {
            column: "one"
        }
    }, /* @__PURE__ */ React4.createElement(UitkLayoutGridItem, {
        colSpan: {
            small: 5,
            medium: 2
        }
    }, /* @__PURE__ */ React4.createElement(UitkCardContentSection3, {
        padded: [
            "inlinestart"
        ]
    }, /* @__PURE__ */ React4.createElement(UitkSpacing3, {
        margin: {
            blockstart: "one"
        }
    }, /* @__PURE__ */ React4.createElement(UitkLayoutFlex, {
        justifyContent: "end",
        alignItems: "center",
        space: "half"
    }, /* @__PURE__ */ React4.createElement(UitkLayoutGrid3, {
        columns: data.readIndicator ? 2 : 1,
        space: "three",
        justifyItems: data.readIndicator ? "center" : "start",
        alignItems: "center"
    }, data.readIndicator && /* @__PURE__ */ React4.createElement(UitkBadgeNotification, {
        theme: "unread",
        visible: true
    }), data.icon && /* @__PURE__ */ React4.createElement(NotificationIcon, {
        data: data.icon
    })))))), /* @__PURE__ */ React4.createElement(UitkLayoutGridItem, {
        colSpan: {
            small: 16,
            medium: 21
        }
    }, /* @__PURE__ */ React4.createElement(UitkCardContentSection3, {
        padded: [
            "inlinestart"
        ]
    }, /* @__PURE__ */ React4.createElement(UitkText2, {
        size: 500,
        theme: data.heading.theme ? themeToUitkTextThemeMap[data.heading.theme] : void 0,
        weight: data.heading.weight ? weightToUitkTextWeightMap[data.heading.weight] : void 0,
        spacing: "half"
    }, data.heading.text), /* @__PURE__ */ React4.createElement(UitkSpacing3, {
        padding: {
            blockstart: "two"
        }
    }, /* @__PURE__ */ React4.createElement(UitkText2, {
        overflow: "truncate-3-lines",
        size: 300,
        theme: data.content.theme ? themeToUitkTextThemeMap[data.content.theme] : void 0,
        weight: data.content.weight ? weightToUitkTextWeightMap[data.content.weight] : void 0
    }, data.content.text)), /* @__PURE__ */ React4.createElement(UitkSpacing3, {
        padding: {
            blockstart: "three"
        }
    }, /* @__PURE__ */ React4.createElement(UitkLink, {
        analytics: {
            id: data.link.action.analytics.referrerId,
            description: data.link.action.analytics.linkName,
            callback: function(referrerId, linkName) {
                trackClick(referrerId, linkName);
            }
        }
    }, /* @__PURE__ */ React4.createElement("button", {
        onClick: handleSetAsReadNotification,
        type: "button"
    }, data.link.text))), /* @__PURE__ */ React4.createElement(UitkSpacing3, {
        padding: {
            blockstart: "one"
        }
    }, /* @__PURE__ */ React4.createElement(UitkText2, {
        size: 300,
        theme: "standard",
        spacing: "two"
    }, data.date)))), /* @__PURE__ */ React4.createElement(UitkLayoutGridItem, {
        colSpan: {
            small: 2,
            medium: 1
        }
    }, /* @__PURE__ */ React4.createElement(UitkCardContentSection3, {
        padded: [
            "inlineend"
        ]
    }, /* @__PURE__ */ React4.createElement(UitkTertiaryButton, {
        type: "button",
        onClick: handleSetAsDismissNotification,
        analytics: {
            id: data.dismissButton.analytics.referrerId,
            description: data.dismissButton.analytics.linkName,
            callback: function(referrerId, linkName) {
                trackClick(referrerId, linkName);
            }
        }
    }, /* @__PURE__ */ React4.createElement(NotificationIcon, {
        data: data.dismissButton.icon
    }))))), showSeparator && /* @__PURE__ */ React4.createElement(UitkSpacingHr, {
        blockMargin: "two"
    }));
};
Notification.displayName = "Notification";
Notification.fragment = notificationFragment;
// src/components/notification-center/notification-center.tsx
var __Query = gql3(_templateObject3(), Notification.fragment);
var NotificationCenter = function(props) {
    var skipSsr = props.skipSsr;
    var context = useBexApi2().context;
    var _useQuery = useQuery(__Query, {
        variables: {
            context: context
        },
        ssr: !skipSsr,
        fetchPolicy: "cache-first",
        nextFetchPolicy: "cache-and-network"
    }), data = _useQuery.data, error = _useQuery.error, loading = _useQuery.loading;
    if (loading) {
        return /* @__PURE__ */ React5.createElement(NotificationCenterLoader, null);
    }
    if (error || !data) {
        return null;
    }
    if (data.retailTravelAgentNotificationCenter.notifications.length === 0) {
        return /* @__PURE__ */ React5.createElement(NotificationCenterEmptyNotifications, {
            footer: data.retailTravelAgentNotificationCenter.footerText,
            header: data.retailTravelAgentNotificationCenter.title
        });
    }
    return /* @__PURE__ */ React5.createElement(React5.Fragment, null, /* @__PURE__ */ React5.createElement(UitkHeading3, {
        size: 3,
        tag: "h2"
    }, data.retailTravelAgentNotificationCenter.title), /* @__PURE__ */ React5.createElement(UitkSpacing4, {
        margin: {
            blockstart: "six"
        }
    }, /* @__PURE__ */ React5.createElement(UitkCard3, {
        border: true
    }, /* @__PURE__ */ React5.createElement(UitkCardContentSection4, {
        border: "top",
        padded: [
            "blockstart"
        ]
    }, /* @__PURE__ */ React5.createElement(UitkLayoutGrid4, {
        rows: data.retailTravelAgentNotificationCenter.notifications.length > 3 ? [
            "88x"
        ] : []
    }, /* @__PURE__ */ React5.createElement(UitkScrollable, {
        direction: "vertical",
        tag: "section"
    }, data.retailTravelAgentNotificationCenter.notifications.map(function(notification, index) {
        return /* @__PURE__ */ React5.createElement(Notification, {
            data: notification,
            key: notification.id,
            showSeparator: index + 1 !== data.retailTravelAgentNotificationCenter.notifications.length,
            queryToRefetch: __Query
        });
    })))), /* @__PURE__ */ React5.createElement(UitkCardContentSection4, {
        padded: [
            "blockstart"
        ]
    }), /* @__PURE__ */ React5.createElement(UitkCardContentSection4, {
        padded: true,
        border: "top"
    }, /* @__PURE__ */ React5.createElement(UitkCardContentSection4, {
        padded: [
            "inlinestart"
        ]
    }, /* @__PURE__ */ React5.createElement(UitkSubheading, {
        tag: "h4"
    }, data.retailTravelAgentNotificationCenter.footerText))))));
};
NotificationCenter.displayName = "sharedui-Notification Center";
export { NotificationCenter };
//# sourceMappingURL=index.js.map